<template>
  <Head title="Testergebnis"></Head>
  <h1 class="h1">Testergebnis</h1>
  <div class="flex items-center justify-between mb-6">
    <test-result :test="test" :exam="test.exam" :results="results"/>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import TestResult from '../../Shared/Test/TestResult'
import Layout from '../../Shared/Layout'

export default {

  name: 'ResultPage',

  components: {
    Head,
    TestResult,
  },

  layout: Layout,

  props: {
    test: {
      type: Object,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>